import React from "react";
import './footer.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

/**
 * Footer component.
 * 
 * This is a functional component that renders the footer of the application. 
 * It uses the `useTranslation` hook from `react-i18next` to provide internationalization.
 * 
 * The `useTranslation` hook returns a `t` function that you can use to get the translated text.
 * The keys passed to the `t` function ('footer.businessId', 'footer.phone', and 'footer.email') 
 * correspond to keys in the translation files.
 * 
 * @returns The Footer component.
 */
export default function Footer() {
  const { t } = useTranslation();

  return (
    <div className="footer">
      <div className="footer-content">

        <div className="footer-section">
          <h3>{t('footer.title')}</h3>
          <p>{t('footer.businessId')}</p>
          <p>{t('footer.description')}</p>
        </div>

        <div className="footer-section">
          <h3>{t('footer.links')}</h3>
          <Link to="/">{t('navbar.home')}</Link>
          <Link to="/products">{t('navbar.products')}</Link>
          <Link to="/services">{t('navbar.services')}</Link>
          <Link to="/contact">{t('navbar.contact')}</Link>
        </div>

        <div className="footer-section">
          <h3>{t('footer.contact')}</h3>
          <a
            href="https://www.google.com/maps/search/?api=1&query=Riihijärventie+6,+90440+Kempele"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            {t('footer.address')}
          </a>
          <a href="mailto:kempelepp@gmail.com">
            <FontAwesomeIcon icon={faEnvelope} />
            kempelepp@gmail.com
          </a>
          <a href="tel:+358449860516">
            <FontAwesomeIcon icon={faPhone} />
            044 9860516
          </a>
        </div>

      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} {t('footer.copyright')}</p>
      </div>
    </div>
  );
}